import { Moment } from "moment";

export type TimeWindowRange = {
  startMinutes: number;
  endMinutes: number;
};

export const momentToClockMinutes = (m: Moment): number =>
  m.hours() * 60 + m.minutes();

export const parseTimeToHours = (time: string): number => {
  const [hours = 0, minutes = 0] = time.split(":").map(Number);
  return hours + minutes / 60;
};

export const getAutoAssignWindowOffsets = (
  start: string,
  end: string,
  hourHeight: number
): { top: number; bottom: number; height: number } => {
  const top = Math.round(parseTimeToHours(start) * hourHeight);
  const bottom = Math.round(parseTimeToHours(end) * hourHeight);
  return { top, bottom, height: Math.max(0, bottom - top) };
};

const layoutStartInsideWindow = (
  layoutStartMinutes: number,
  window: TimeWindowRange
): boolean =>
  layoutStartMinutes >= window.startMinutes &&
  layoutStartMinutes < window.endMinutes;

/**
 * Returns true when the layout start falls inside any time window for the
 * given workOrderTemplateId. Overhang past a window end is allowed; only the
 * layout start must land inside some window. Returns true (no constraint) when
 * workOrderTemplateId is absent or that template has no windows in
 * templateWindowsById.
 */
export const layoutIntervalFitsAnyTemplateWindow = (
  workOrderTemplateId: string | undefined,
  layoutStart: Moment,
  templateWindowsById: Record<string, TimeWindowRange[]>
): boolean => {
  if (!workOrderTemplateId) return true;
  const windows = templateWindowsById[workOrderTemplateId];
  if (!windows?.length) return true;

  const layoutStartMinutes = momentToClockMinutes(layoutStart);

  return windows.some((w) => layoutStartInsideWindow(layoutStartMinutes, w));
};
